import React from "react";
import "./Settings.scss";
import dashboardIcon from "../../images/settings-dashboard.svg";
import programIcon from "../../images/settings-program.svg";
import CRMIcon from "../../images/settings-crm.svg";
import reportingIcon from "../../images/settings-reporting.svg";
import marketingIcon from "../../images/settings-marketing.svg";
import batchIcon from "../../images/settings-batch.svg";
import settingsIcon from "../../images/settings-settings.svg";
import helpcenterIcon from "../../images/settings-helpcenter.svg";
import seucrity from "../../images/shield-search.svg";
import marketPlace from "../../images/home-hashtag.svg";
import collaborate from "../../images/profile-2user.svg";
import { Link } from "react-router-dom";
import { Box, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";

function Settings() {
  //loop through the setting options to add it to the list of settings
  //will need to add url to the link to navigate to the correct page
  let configVariables = useSelector((state) => state.config.baseConfig);

  const decodeHTML = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};


const raw = configVariables.portalMiniApps;
const raw2 = configVariables.portalMiniApps2;
const decoded = decodeHTML(raw);
const decoded2 = decodeHTML(raw2);
 const miniApps = JSON.parse(decoded);
 const miniApps2 = JSON.parse(decoded2);

 console.log("miniApps", miniApps);
 console.log("miniApps2", miniApps2); // { dashboard: true }

  // console.log("config value check",configVariables.portalMiniApps);
  // console.log("config value parse check",JSON.parse(configVariables.portalMiniApps));


  const settingOptions = [
    {
      icon: dashboardIcon,
      option: "Dashboard",
      description: "Billing, security, audit log, adn other account essentials",
      link: "/dashboard",
      show: miniApps.dashboard || miniApps2.dashboard,
    },
    {
      icon: programIcon,
      option: "Licenses",
      description:
        "Team management, user and organization fields, bulk actions, and tags",
      link: "/dashboard",
      show: miniApps.licenses || miniApps2.licenses,
    },
    {
      icon: CRMIcon,
      option: "CRM",
      description:
        "Ways to connect with customers, from email and Talk to messaging and Flow Builder",
      link: "/crm",
      show: miniApps.crm || miniApps2.crm,
    },
    {
      icon: reportingIcon,
      option: "Reporting",
      description:
        "Managing how team members use Zendesk, from views and macros to Agent Workspace",
      link: "/reporting",
      show: miniApps.reporting || miniApps2.reporting,
    },
    {
      icon: marketingIcon,
      option: "Marketing",
      description: "Ticket fields, triggers, automations, and more",
      link: "/dashboard",
      show: miniApps.marketing || miniApps2.marketing,
    },
    {
      icon: batchIcon,
      option: "Batch Services",
      description:
        "Apps, APIs, targets, webhooks, and other ways to get data in and out of Zendesk",
      link: "/batch",
      show: miniApps.batchServices || miniApps2.batchServices,
    },
    // {
    //   icon: settingsIcon,
    //   option: "Settings",
    //   description: "Tips and answers to your questions about Admin Center",
    // },
    {
      icon: helpcenterIcon,
      option: "Business Rules",
      description: "Tips and answers to your questions about Admin Center",
      link: "/dashboard",
      show: miniApps.businessRules || miniApps2.businessRules,
    },
    {
      icon: seucrity,
      option: "Security",
      description: "Tips and answers to your questions about Admin Center",
      link: "/dashboard",
      show: miniApps.security || miniApps2.security,
    },
    {
      icon: settingsIcon,
      option: "Help Center",
      description: "Tips and answers to your questions about Admin Center",
      link: "/dashboard",
      show: miniApps.helpCenter || miniApps2.helpCenter,
    },
    {
      icon: marketPlace,
      option: "Marketplace",
      description:
        "Quickly manage modules in your CBS to extend new capabilities and services.",
      link: "/marketplace",
      show: miniApps.marketplace || miniApps2.marketplace,
    },
    {
      icon: collaborate,
      option: "Collaborate (CoFi) Lab",
      description:
        "Transforming the financial services landscape through Collaborative Finance (CoFi). Connect with forward-thinking businesses ready to collaborate.",
      link: "/cofilab",
      show: miniApps.collaborate || miniApps2.collaborate,
    },
    {
      icon: collaborate,
      option: "CS DEMO (Credit Scoring)",
      description:
        "A comprehensive tool for managing customer data, processing loan applications, and overseeing loan repayments",
      link: "/credit-scoring",
      show: miniApps.csDemo || miniApps2.csDemo,
    },
      {
        icon: collaborate,
        option: "Loan Setup",
        description:
          "A comprehensive tool for managing loans",
        link: "/loansetup",
        show: miniApps.loanSetup || miniApps2.loanSetup,
      },
      {
        icon: collaborate,
        option: "Loan Rule Setup",
        description:
          "Configure eligibility rules, interest rates, tenures, fees, and approval criteria for loan products",
        link: "/loan-rule-setup",
        show: miniApps.loanRuleSetup || miniApps2.loanRuleSetup,
      },
      {
        icon: collaborate,
        option: "Loan Reports",
        description:
          "A comprehensive tool for viewing loan reports",
        link: "/loanreports",
        show: miniApps.loanReports || miniApps2.loanReports,
      }
      ,
      {
        icon: collaborate,
        option: "Fees Module",
        description:
          "A comprehensive tool for managing fees",
        link: "/fees-setup",
        show: miniApps.feesModule || miniApps2.feesModule,
      },
      {
        icon: collaborate,
        option: "Fees Module New",
        description:
          "A comprehensive tool for managing fees",
        link: "/fees-setup-new",
        show: miniApps.feesModule || miniApps2.feesModule,
      }
  ];

  return (
    <Box className="page-container" sx={{mb: 3}}>
      <Box className="header-container">
        <Box className={`page-title`}>Admin Center</Box>
        <Box>
          Your home for settings to manage your account, team, and more.
        </Box>
      </Box>

      <Box className="settings-center-container">
        <Grid container spacing={3}>
          {settingOptions.map((setting) => (
            (setting.show && 
            <Grid item xs={12} sm={6} md={4} lg={3} key={setting.option}>
              <Box 
                className="settings-card"
                sx={{ minHeight: '250px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
              >
                <Link to={setting.link}>
                  <Box className="settings-card-title-container d-flex align-items-center">
                    <img src={setting.icon} alt={setting.option} loading="lazy" />
                    <Typography variant="h9">{setting.option}</Typography>
                  </Box>
                  <Box className="settings-card-body">{setting.description}</Box>
                  <Box to={setting.link} className="settings-card-link">
                    {setting.option}
                  </Box>
                </Link>
              </Box>
            </Grid>
          )
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default Settings;